import { useContext, useEffect } from "react"
import { useFormikContext } from "formik"
import styles from "../../../styles/Form.module.css"
import { FormContext } from "../../../context/formContext"

export default function SessionId({ field, index }) {
  const formik = useFormikContext()
  const form = useContext(FormContext)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    formik.setFieldValue(field.field_name, "not-set")

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}
